import { SxProps, Theme } from "@mui/material";

import { BANNER_COLORS } from "./constants";

export const advertiseNowBannerStyles = {
  card: {
    width: "100%",
    borderRadius: "16px",
    bgcolor: BANNER_COLORS.neutralWhite,
    border: `1px solid ${BANNER_COLORS.neutralGray300}`,
    boxShadow: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: BANNER_COLORS.accent,
      boxShadow: "none",
    },
  } satisfies SxProps<Theme>,

  cardContent: {
    p: { xs: 2.5, md: 3 },
  } satisfies SxProps<Theme>,

  mainRow: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    justifyContent: "space-between",
    gap: 2,
  } satisfies SxProps<Theme>,

  contentGroup: {
    display: "flex",
    alignItems: "center",
    gap: { xs: 1.5, md: 2.5 },
    flex: 1,
  } satisfies SxProps<Theme>,

  iconContainer: {
    width: { xs: 40, md: 52 },
    height: { xs: 40, md: 52 },
    bgcolor: BANNER_COLORS.accentLight,
    borderRadius: { xs: "12px", md: "14px" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  } satisfies SxProps<Theme>,

  decorativeIcon: {
    fontSize: { xs: 22, md: 28 },
    color: BANNER_COLORS.accent,
  } satisfies SxProps<Theme>,

  title: {
    fontWeight: 600,
    color: BANNER_COLORS.neutralGray900,
    mb: 0.5,
    fontSize: { xs: "1rem", md: "1.125rem" },
    lineHeight: 1.3,
  } satisfies SxProps<Theme>,

  description: {
    color: BANNER_COLORS.neutralGray600,
    maxWidth: 400,
    fontSize: { xs: "0.8125rem", md: "0.875rem" },
    lineHeight: 1.4,
  } satisfies SxProps<Theme>,

  ctaButton: {
    bgcolor: BANNER_COLORS.accent,
    color: BANNER_COLORS.neutralWhite,
    borderRadius: "40px",
    px: 3.5,
    py: 1.25,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.875rem",
    boxShadow: "none",
    whiteSpace: "nowrap",
    width: { xs: "100%", md: "auto" },
    flexShrink: 0,
    transition: "all 0.2s ease",
    "&:hover": {
      bgcolor: BANNER_COLORS.accentDark,
      boxShadow: "none",
    },
  } satisfies SxProps<Theme>,

  ctaIcon: {
    fontSize: 18,
    color: BANNER_COLORS.neutralWhite,
  } satisfies SxProps<Theme>,

  benefitsRow: {
    display: "flex",
    gap: { xs: 2, md: 3 },
    mt: { xs: 1.5, md: 2.5 },
    pt: { xs: 1.5, md: 2 },
    borderTop: `1px solid ${BANNER_COLORS.neutralGray100}`,
    flexWrap: "wrap",
    justifyContent: { xs: "center", md: "flex-start" },
  } satisfies SxProps<Theme>,

  benefitItem: {
    display: "flex",
    alignItems: "center",
    gap: { xs: 0.5, md: 1 },
  } satisfies SxProps<Theme>,

  benefitItemDesktopOnly: {
    display: { xs: "none", md: "flex" },
  } satisfies SxProps<Theme>,

  benefitIcon: {
    fontSize: { xs: 12, md: 14 },
    color: BANNER_COLORS.accent,
  } satisfies SxProps<Theme>,

  benefitLabelDesktop: {
    display: { xs: "none", md: "block" },
    color: BANNER_COLORS.neutralGray600,
    fontWeight: 500,
    fontSize: "0.75rem",
  } satisfies SxProps<Theme>,

  benefitLabelMobile: {
    display: { xs: "block", md: "none" },
    color: BANNER_COLORS.neutralGray600,
    fontSize: "0.6875rem",
  } satisfies SxProps<Theme>,
} as const;
